import React, { useContext, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { signInWithGoogle, auth } from "../firebase";

import { ColorModeContext } from "../context/ColorModeProvider";

import SignInForm from "./SignInForm";

import { toast } from "react-toastify"; // then this

import {
  CssBaseline,
  Container,
  Box,
  Grid,
  Card,
  Typography,
  Button,
  TextField,
  Stack,
} from "@mui/material";
import GoogleIcon from "@mui/icons-material/Google";

import styled from "@emotion/styled";

const StyledBox = styled(Box)``;

const SignIn = () => {
  const { theme } = useContext(ColorModeContext);

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const history = useHistory("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (email && password) {
      try {
        const { user } = await auth.signInWithEmailAndPassword(email, password);

        // Alert.success("Successfully Signed In", 2000);
        toast.success("Welcome back!", {
          theme: "colored",
        });
        history.push("/dashboard");
      } catch (error) {
        // Alert.error(error.message, 3000);
        toast.error(`${error.message}`, {
          theme: "colored",
        });
      }
    } else {
      // Alert.error("Fields are empty", 3000);
      toast.error("Fields are empty", {
        theme: "colored",
      });
    }
  };
  return (
    <Container size="sm">
      <CssBaseline />
      <Grid
        container
        spacing={0}
        // style={{ minWidth: "600px" }}
        style={{
          minHeight: "100vh",
          justifyContent: "center",
          display: "flex",
        }}
      >
        <Grid item xs={12} md={6}>
          <Typography
            variant="h4"
            color={theme.palette.mode === "dark" ? "#fff" : "#254c73"}
            component="h2"
            gutterBottom
          >
            Login
          </Typography>
          <SignInForm />
        </Grid>
      </Grid>
    </Container>
  );
};

export default SignIn;
